import { Form, Field } from 'formik';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import styled from '@emotion/styled';
import { Flex, Text, Button, Box } from 'rebass';
import { IoMdClose } from "react-icons/io";
import CoverPhoto from './async-cover';

import { CurrentCollectionContext } from '../../../collections/current-collection-context';
import DateField from '../../../app/form/formik/date';
import StoryTagsManager from '../../tags/manager';
import TagList from '../../tags/tag-list';
import TextField from '../../../app/form/formik/text';
import { Label } from 'app/form/formik/text/styled';

const ButtonsWrap = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: max-content max-content;
  justify-content: space-between;
  margin-bottom: 40px;
`;

const FieldsWrap = styled.div`
  display: grid;
  grid-gap: ${props => props.theme.gutter};
  align-items: stretch;  
  padding: ${props => props.theme.gutter};

  input {
    width: 100%;
  }
`;

const StoryForm = ({ values, handleCancel, toggleTags, isShowingTags, hasTags, showCoverPhoto, isSubmitting, error }) => {

  const [hideEndDate, setHideEndDate] = useState(!values['ended-on'])

  const { currentCollection: collection } = useContext(CurrentCollectionContext);
  if (isShowingTags) {
    return (
      <StoryTagsManager
        collection={collection}
        storyId={values.id}
        onSuccess={toggleTags}
        onClose={toggleTags}
      />
    );
  }

  return (
    <Form autoComplete="off">
      <FieldsWrap>
        <Field
          placeholder="Christmas Dinner, Trip to Cuba, Baking Contest"
          name="title"
          label="Story Title"
          showError
          component={TextField}
        />
        <Flex flexDirection='column' alignItems={[null, 'flex-end']}>
          <Field
            name="began-on"
            label="Story Start Date"
            placeholder="Start Date"
            maxDate={values['ended-on']}
            component={DateField}
            width="auto"
          />
          {hideEndDate ? <Text mr="auto"
            fontFamily="Poppins"
            sx={{ cursor: 'pointer' }}
            color="#9B59B6"
            fontSize="16px"
            fontWeight={400}
            lineHeight="20px"
            onClick={() => setHideEndDate(false)}
          >Add story end date</Text>
            : <Flex mr="auto">
              <Field
                name="ended-on"
                label="Story End Date"
                minDate={values['began-on']}
                component={DateField}
                width="auto"
              />
              <IoMdClose size={24} onClick={() => setHideEndDate(true)} />
            </Flex>
          }
        </Flex>
        {hasTags && <TagList id={values.id} onClick={toggleTags} />}
        {!isShowingTags && showCoverPhoto && <Box>
          <Label >Story Preview Photo</Label>
          <CoverPhoto id={values.id} />
        </Box>}
        {!!error && (
          <Text fontFamily="Poppins" fontSize="14px" color="red">
            {error?.response?.data?.errors?.[0]?.detail || "We couldn't save that. Please try again."}
          </Text>
        )}
        <ButtonsWrap>
          <Button
            type="button"
            onClick={handleCancel}
            height={44}
            fontSize={16}
            fontFamily="Poppins"
            py="unset"
            px={3}
            fontWeight={500}
            lineHeight="120%"
            letterSpacing="-0.352px"
            color="#64748B"
            variant="outline"
            css="border-radius:23px;"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            height={44}
            variant="primary"
            p="10px 20px"
            disabled={isSubmitting}
            css="grid-column: 3 / 4; justify-self: end; border-radius:23px;"
          >
            {isSubmitting ? 'Saving' : 'Save'}
          </Button>
        </ButtonsWrap>
      </FieldsWrap>
    </Form>
  );
};

StoryForm.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  toggleTags: PropTypes.func.isRequired,
  isShowingTags: PropTypes.bool,
  hasTags: PropTypes.bool,
  showCoverPhoto: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  error: PropTypes.object,
  values: PropTypes.shape({}),
  collection: PropTypes.shape({
    type: PropTypes.string,
    id: PropTypes.string,
  }),
};

StoryForm.defaultProps = {
  isShowingTags: false,
  hasTags: false,
  showCoverPhoto: true,
  isSubmitting: false,
  error: null,
  values: {},
  collection: {
    type: '',
    id: '',
  },
};

export default withRouter(StoryForm);
